import { render, staticRenderFns } from "./IconResolveNote.vue?vue&type=template&id=2a77bd8c"
import script from "./IconResolveNote.vue?vue&type=script&lang=js"
export * from "./IconResolveNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports